import LoyaltyMembersDayBanner from "../LoyaltyMembersDay/Banner";
import addLoyaltyBanner from "../../helpers/addLoyaltyBanner";

const addLoyaltyMembersDayBanner = ({
  viewportCategory,
  positionFinder,
  items
}) =>
  addLoyaltyBanner({
    viewportCategory,
    positionFinder,
    items,
    BannerComponent: <LoyaltyMembersDayBanner key="loyaltyMembersDayBanner" />
  });

export default addLoyaltyMembersDayBanner;
